import { createSlice } from '@reduxjs/toolkit';
import { fetchReferralUsage } from '../thunks/referral';

const initialState = {
  referral: [],
  fetching: false,
  fetchError: '',
  saving: false,
  saveError: '',
  meta: {},
};

export const referralSlice = createSlice({
  name: 'referral',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchReferralUsage.pending]: (state) => {
      state.fetching = true;
    },
    [fetchReferralUsage.fulfilled]: (state, action) => {
      const { meta, referral_usages } = action.payload;
      state.fetching = false;
      state.referral = referral_usages;
      state.meta = meta;
    },
    [fetchReferralUsage.rejected]: (state, action) => {
      state.fetching = false;
      state.fetchError = action.payload.error;
    },
  },
});
